import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HelpCircleIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { offer } from '../data/offer';
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-ink px-5 py-20 sm:py-24" data-id="element-70" data-mp="1ntzyb9vert1u">
      <div className="mx-auto max-w-3xl" data-id="element-71" data-mp="2bkm4swprl59q">
        <h2 id="faq" className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase text-white sm:text-4xl" data-id="element-72" data-mp="2blnf2yyyhnqe">
          <HelpCircleIcon className="h-8 w-8 text-brand" aria-hidden="true" data-id="element-73" data-mp="2fns75t9racax" />
          Lo que más nos preguntan
        </h2>
        <ul className="mt-10 divide-y divide-line border-y border-line" data-id="element-74" data-mp="26t41w346kum4">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-75" data-mp="2uhdi8pimkq5v" data-mpi={i}>
                <h3 data-id="element-76" data-mp="2zagh9d668rtg">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left text-lg font-black text-white transition-colors duration-150 ease-out hover:text-brand focus:outline-none focus-visible:text-brand" data-id="element-77" data-mp="2zazw2l0iz039">
                    {f.q}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-78" data-mp="2fcz0pr5j7gfs" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-79" data-mp="2jflmbabm054j">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-80" data-mp="2jdizt09o0u4k">
                      <div className="space-y-3 pb-6 text-base leading-relaxed text-cream/85" data-id="element-81" data-mp="2u4hzruwobnwx">
                        {f.a.map(p => <p key={p} data-id="element-82" data-mp="333ligxrxi1aw">{p}</p>)}
                        {f.email && <a href={`mailto:${offer.email}`} className="font-bold text-sun underline-offset-4 hover:underline" data-id="element-83" data-mp="381es60sfxdfx">
                            {offer.email}
                          </a>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}